import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhatIsSection from './components/WhatIsSection';
import WhyChooseSection from './components/WhyChooseSection';
import ComparisonTable from './components/ComparisonTable';
import CategoryGrid from './components/CategoryGrid';
import LatestGuides from './components/LatestGuides';
import SecuritySection from './components/SecuritySection';
import NewsletterSection from './components/NewsletterSection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';
import { buildWebSiteSchema, buildOrganizationSchema, buildWebPageSchema } from '@/lib/seo';

export default function Home() {
  return (
    <main>
      <JsonLd
        data={[
          buildWebSiteSchema(),
          buildOrganizationSchema(),
          buildWebPageSchema(
            'Basetao Spreadsheet: Complete Guide, Reviews & Templates',
            'Comprehensive Basetao Spreadsheet resource platform featuring reviews, shipping guides, coupons, and templates.',
            '/'
          ),
        ]}
      />
      <Navbar />
      <Hero />
      <WhatIsSection />
      <WhyChooseSection />
      <ComparisonTable />
      <CategoryGrid />
      <LatestGuides />
      <SecuritySection />
      <NewsletterSection />

      <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Ready To Master Basetao Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-xl mx-auto">
            Visit our main website and discover powerful spreadsheet solutions designed to streamline your sourcing workflow.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-base hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Basetao Spreadsheet
              <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg border-2 border-primary-500 text-primary-600 font-semibold text-base hover:bg-primary-50 transition-all whitespace-nowrap cursor-pointer"
            >
              Visit Official Website
              <i className="ri-external-link-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}